export var STATE;
(function (STATE) {
    STATE[STATE["closed"] = 0] = "closed";
    STATE[STATE["flag"] = 1] = "flag";
    STATE[STATE["question"] = 2] = "question";
    STATE[STATE["flat"] = 3] = "flat";
    STATE[STATE["open"] = 4] = "open";
    STATE[STATE["wrong_flag"] = 5] = "wrong_flag";
})(STATE || (STATE = {}));
export var NUM;
(function (NUM) {
    NUM[NUM["zero"] = 0] = "zero";
    NUM[NUM["one"] = 1] = "one";
    NUM[NUM["two"] = 2] = "two";
    NUM[NUM["three"] = 3] = "three";
    NUM[NUM["four"] = 4] = "four";
    NUM[NUM["five"] = 5] = "five";
    NUM[NUM["six"] = 6] = "six";
    NUM[NUM["seven"] = 7] = "seven";
    NUM[NUM["eight"] = 8] = "eight";
})(NUM || (NUM = {}));
export var ACTION;
(function (ACTION) {
    ACTION[ACTION["OPEN"] = 0] = "OPEN";
    ACTION[ACTION["FLAG"] = 2] = "FLAG";
})(ACTION || (ACTION = {}));
export var GAMESTATE;
(function (GAMESTATE) {
    GAMESTATE[GAMESTATE["WON"] = 0] = "WON";
    GAMESTATE[GAMESTATE["LOST"] = 1] = "LOST";
    GAMESTATE[GAMESTATE["ACTIVE"] = 2] = "ACTIVE";
    GAMESTATE[GAMESTATE["UNSTARTED"] = 3] = "UNSTARTED";
})(GAMESTATE || (GAMESTATE = {}));
